import { app } from '../../../../../app';
import { Controller } from './remove-group.controller';

app.component('companyUserDirectoriesManageGroupRemove', {
    bindings: {close: '&', dismiss: '&', resolve: '<'},
    controller: Controller,
    templateUrl: require('./remove-group.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-group/remove/remove-group.component.js